import { useQuery } from '@tanstack/vue-query'
import { storeToRefs } from 'pinia'

import { useAuthStore } from '@/store/auth'

import { handleApiErrorToast } from '..'
import { ModelsApi } from '../modules/models'

import type { IPaginatedResponse } from '..'
import type { IModel } from '../types/model'

export const modelsQueryKey = ['models'] as const

export const useModelQueries = () => {
  const { isAuthenticated } = storeToRefs(useAuthStore())

  const list = () =>
    useQuery<IPaginatedResponse<IModel>>({
      queryKey: modelsQueryKey,
      queryFn: () => ModelsApi.list().catch(handleApiErrorToast),
      staleTime: Infinity, // Setting to Infinity since models are unlikely to change
      enabled: isAuthenticated,
    })

  return {
    list,
  }
}
